import React from 'react';
import philips_logo from '../../images/philips_logo.png';
import baxter_logo from '../../images/baxter_logo.png';
import ucla_logo from '../../images/ucla_logo.png';
import johns_hopkins_logo from '../../images/johns_hopkins_logo.png';
import {Panel, PanelType} from '../../components';
import {BrowserView, MobileView} from "react-device-detect";

export const ClientsPanel: React.FC = () => {

    const ClientContainer = ({ name, logo }: { name: string; logo: string }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: '300px',
                height: '200px',
                borderRadius: '18px',
                overflow: 'hidden',
                boxShadow: 'rgb(0, 0, 0, 0.1) 5px 5px 15px',
            }}>
                <div style={{
                    height: '200px'
                }}>
                    <img src={logo} alt={name} width="100%" height="100%" />
                </div>
            </div>
        );
    };

    return (
        <>
        <MobileView>
            <Panel type={PanelType.LIGHT}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                }}>
                    <div style={{
                        fontSize: '2.1rem',
                        fontWeight: 500,
                        textAlign: 'center',
                        width: '100%',
                        lineHeight: 1.3,
                    }}>
                        Clients & Partners
                    </div>
                    <div style={{
                        fontSize: '1.2rem',
                        color: 'rgb(150, 150, 150)',
                        textAlign: 'center',
                        paddingTop: '15px',
                        paddingLeft: '60px',
                        paddingRight: '60px',
                    }}>leaders in medtech sharing in our vision for the future</div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '30px',
                        width: '100%',
                        marginTop: '45px',
                        marginBottom: '20px',
                    }}>
                        <ClientContainer name="Philips" logo={philips_logo} />
                        <ClientContainer name="Baxter" logo={baxter_logo} />
                        <ClientContainer name="UCLA" logo={ucla_logo} />
                        <ClientContainer name="Johns Hopkins" logo={johns_hopkins_logo} />
                    </div>
                </div>
            </Panel>
        </MobileView>
        <BrowserView>
            <Panel type={PanelType.LIGHT}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    marginLeft: 75,
                    marginRight: 75,
                }}>
                    <div style={{fontSize: '3.5rem'}}>
                        Clients & Partners <span style={{fontSize: '1.1rem', color: 'rgb(150, 150, 150)'}}>— leaders in medtech sharing in our vision for the future.</span>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '30px',
                        width: '100%',
                        marginTop: '75px',
                        marginBottom: '75px',
                    }}>
                        <ClientContainer name="Philips" logo={philips_logo} />
                        <ClientContainer name="Baxter" logo={baxter_logo} />
                        <ClientContainer name="UCLA" logo={ucla_logo} />
                        <ClientContainer name="Johns Hopkins" logo={johns_hopkins_logo} />
                    </div>
                </div>
            </Panel>
        </BrowserView>
        </>
    );
};